import { FemaleIcon } from "@images/svgIcons/femaleIcon"
import { MaleIcon } from "@images/svgIcons/maleIcon"
import { word } from "@modules/core/utils/i18n"
import { ProfileLabelVisibility } from "@modules/profile/myProfile/components/profileLabelVisibility"
import { ProfileFormTabProps } from "@modules/profile/myProfile/profileFormikType"
import { FormikInput } from "@modules/ui/components/formikInput"
import { HUText } from "@modules/ui/components/huText"
import { HURow, HUStack } from "@modules/ui/components/layout"
import { displayedFullDateFormat } from "@modules/utils/dateUtils"
import dayjs from "dayjs"
import styled, { useTheme } from "styled-components"

export const CrossfitInformationForm: React.FC<ProfileFormTabProps> = ({
  isFormFieldInValid,
  getFormErrorMessage,
  formik,
}) => {
  const theme = useTheme()

  const handleSelectGender = (gender: "MALE" | "FEMALE") => {
    formik.setFieldValue("genderCategory", gender)
  }

  return (
    <div className="flex flex-grow-1 flex-column justify-content-start mt-6 gap-4 px-4">
      <HUText fontStyle="TM" className="align-self-center mb-4">
        {word("profile.form.crossfit.title")}
      </HUText>

      {/* CrossFit starting date input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.crossfitStartDate.label")}
          name="crossfitStartDate"
          isInvalid={isFormFieldInValid("crossfitStartDate")}
          displayVisibleToggle
          visibility={formik.getFieldProps("crossfitStartDateVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue(
              "crossfitStartDateVisibility",
              !formik.getFieldProps("crossfitStartDateVisibility").value,
            )
          }
        />
        <FormikInput
          isInvalid={isFormFieldInValid("crossfitStartDate")}
          getFieldProps={formik.getFieldProps}
          name="crossfitStartDate"
          error={getFormErrorMessage("crossfitStartDate")}
          placeHolder={word("profile.form.crossfitStartDate.label")}
          type="calendar"
          calendarProps={{
            maxDate: dayjs().toDate(),
            showIcon: true,
            className: "flex-1",
            dateFormat: displayedFullDateFormat,
          }}
        />
      </HUStack>

      {/* Gender category input */}
      <HUStack gap={6}>
        <ProfileLabelVisibility
          label={word("profile.form.genderCategory.label")}
          name="genderCategory"
          isInvalid={isFormFieldInValid("genderCategory")}
          displayVisibleToggle
          visibility={formik.getFieldProps("genderCategoryVisibility").value}
          onToggleVisibility={() =>
            formik.setFieldValue("genderCategoryVisibility", !formik.getFieldProps("genderCategoryVisibility").value)
          }
        />
        <HUText fontStyle="BS" style={{ whiteSpace: "pre-line", overflowWrap: "break-word" }}>
          {word("profile.form.genderCategory.description")}
        </HUText>
      </HUStack>
      <HURow className="justify-content-center mt-4">
        <GenderContainer>
          <GenderOption
            onClick={() => handleSelectGender("FEMALE")}
            selected={formik.getFieldProps("genderCategory").value === "FEMALE"}
            className="mr-2 flex justify-content-center align-items-center "
          >
            <HUStack className="justify-content-center align-items-center">
              <ContainerImage>
                <FemaleIcon color={theme.neutralColor600} />
              </ContainerImage>
              <HUText>{word("scoreboard.filters.female")}</HUText>
            </HUStack>
          </GenderOption>
          <GenderOption
            onClick={() => handleSelectGender("MALE")}
            selected={formik.getFieldProps("genderCategory").value === "MALE"}
            className="ml-2 flex justify-content-center align-items-center "
          >
            <HUStack className="justify-content-center align-items-center">
              <ContainerImage>
                <MaleIcon className="mt-2" color={theme.neutralColor600} />
              </ContainerImage>
              <HUText>{word("scoreboard.filters.male")}</HUText>
            </HUStack>
          </GenderOption>
        </GenderContainer>
      </HURow>
    </div>
  )
}

const GenderContainer = styled(HURow)`
  width: 285px;
  justify-content: space-between;
`

const ContainerImage = styled.div`
  height: 45px;
`

const GenderOption = styled.div<{ selected?: boolean }>`
  background-color: ${({ selected, theme }) => (selected ? theme.primaryColor : theme.neutralColor200)};
  color: ${({ selected, theme }) => (selected ? theme.neutralColor100 : theme.textPrimary)};
  padding: 16px;
  border-radius: 8px;
  width: 132px;
  height: 191px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColor400};
    color: ${({ theme }) => theme.neutralColor100};
  }
`
